import { render, staticRenderFns } from "./busi.vue?vue&type=template&id=3466328e&"
import script from "./busi.vue?vue&type=script&lang=js&"
export * from "./busi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports